import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../user";

export const FETCH_DELETE_USERS_REQUEST = 'FETCH_DELETE_USERS_REQUEST';
export const FETCH_DELETE_USERS_SUCCESS = 'FETCH_DELETE_USERS_SUCCESS';
export const FETCH_DELETE_USERS_FAILURE = 'FETCH_DELETE_USERS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteUsersRequest = () => {
    return {
        type: FETCH_DELETE_USERS_REQUEST,
    };
};

const fetchDeleteUsersSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_USERS_SUCCESS,
        payload: data
    };
};

const fetchDeleteUsersFailure = (error: any) => {
    return {
        type: FETCH_DELETE_USERS_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteUsersRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteUsersSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteUsersFailure(error.message));
        }
    };
};
